var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Paper',{staticClass:"color-block",style:(_vm.styles)},[_c('RatioBox',{attrs:{"ratio":1}},[_c('span',{staticClass:"color-block__text"},[_vm._v(_vm._s(_vm.color))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }